var exports = {
  "N": "idle__PIhf9I",
};

module.exports = exports;
